import { Component, OnInit, Inject, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectInputModel, RicercaPraticheService } from 'src/app/services/ricerca-pratiche.service';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-richiesta-integrazione-new-modal',
  templateUrl: './richiesta-integrazione-new-modal.component.html',
  styleUrls: ['./richiesta-integrazione-new-modal.component.scss']
})
export class RichiestaIntegrazioneNewModalComponent implements OnInit {

  idTipoDocumento: number = 4;
  idTipoDocumentoPa: number = 17;
  currentValue: any;
  @Input() emailValue: number = 1;
  @Input() pecValue: number = 2;
  @Input() tipiAllegati: SelectInputModel[] = [];
  @Output() valueChange = new EventEmitter<any>();
  
  public integrazioneForm: FormGroup = this.formBuilder.group({
    tipoDestinatario: ['1', Validators.required],
    emailType: ['1', Validators.required],
    emailDestinatarioPA: [null],
    emailDestinatario: [null, Validators.required],
    emailBody: [null, Validators.required],
    emailBodyPA: [null],
    allegatiDaIntegrare: [null]
  });

  ngOnInit() {
    this.integrazioneForm.get('emailDestinatario').setValue(this.data.richiedentePrincipaleEmailAddress);
    if (this.data.idPratica) this.ricercaPraticaSrv.getHtmlTemplate(this.idTipoDocumento, this.data.idPratica).toPromise().then(val => {
      this.integrazioneForm.get('emailBody').patchValue(val);
    }).catch(err => {
      console.error(err);
    });
    if (this.data.idPratica) this.ricercaPraticaSrv.getHtmlTemplate(this.idTipoDocumentoPa, this.data.idPratica).toPromise().then(val => {
      this.integrazioneForm.get('emailBodyPA').patchValue(val);
    }).catch(err => {
      console.error(err);
    });
  }

  constructor(
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<RichiestaIntegrazioneNewModalComponent>,
    private ricercaPraticaSrv: RicercaPraticheService,
    protected changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: { header: string, text: string, modalParam: any, tipoAllegato: SelectInputModel[], richiedentePrincipaleEmailAddress: string, idPratica, idIstitutoGaranzia }) {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onValueChange(event: any) {
    this.currentValue = event;
    this.valueChange.emit(this.currentValue);
  }

  getOutPutData() {
    if ((this.integrazioneForm.value.tipoDestinatario === '1' && this.integrazioneForm.get('allegatiDaIntegrare').value)
      || this.integrazioneForm.value.tipoDestinatario === '2') {
      const outputData = this.integrazioneForm.value;
      const outputDataTemp = {
        emailType: { id: outputData.emailType }, 
        tipoIntegrazione: (outputData.emailDestinatarioPA) ? 'PA' : null, 
        emailBody: (outputData.emailBody) ? outputData.emailBody : outputData.emailBodyPA, 
        emailDestinatario: (outputData.emailDestinatario) ? outputData.emailDestinatario : outputData.emailDestinatarioPA,
        allegatiDaIntegrare: this.integrazioneForm.value.tipoDestinatario === '1' ?
                            this.integrazioneForm.get('allegatiDaIntegrare').value.map(value => {
                              const tipoDoc = this.data.tipoAllegato.find(val => val.id === value);
                              if (tipoDoc) return { idTipoAllegato: tipoDoc.id, descrizioneTipoAllegato: tipoDoc.descrizione };
                              else return null;
                            }) : [],
        dataRichiesta: new Date(),
        dataUtilizzo: new Date()
      };
      this.dialogRef.close(outputDataTemp);
    }
  }

  toggleDestinatario(event: any) {
    if (event.target.value === '1') {
      if (this.data.idPratica) this.ricercaPraticaSrv.getHtmlTemplate(this.idTipoDocumento, this.data.idPratica).toPromise().then(val => {
        this.integrazioneForm.get('emailBody').patchValue(val);
      }).catch(err => { console.error(err); });
      this.integrazioneForm.get('emailDestinatario').setValue(this.data.richiedentePrincipaleEmailAddress);
      this.integrazioneForm.get('emailDestinatario').setValidators([Validators.required]);
      this.integrazioneForm.get('emailBody').setValidators([Validators.required]);
      this.integrazioneForm.get('emailDestinatarioPA').clearValidators();
      this.integrazioneForm.get('emailBodyPA').clearValidators();
      this.integrazioneForm.get('emailDestinatarioPA').patchValue(null);
      this.integrazioneForm.get('emailBodyPA').patchValue(null);
    } else if (event.target.value === '2') {
      if (this.data.idPratica) this.ricercaPraticaSrv.getHtmlTemplate(this.idTipoDocumentoPa, this.data.idPratica).toPromise().then(val => {
        this.integrazioneForm.get('emailBodyPA').patchValue(val);
      }).catch(err => { console.error(err); });
      this.integrazioneForm.get('emailDestinatarioPA').setValidators([Validators.required, Validators.maxLength(60), Validators.pattern('^[_A-Za-z0-9-+](.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(.[A-Za-z0-9]+)*(.[A-Za-z]{2,})$')]);
      this.integrazioneForm.get('emailBodyPA').setValidators([Validators.required]);
      this.integrazioneForm.get('emailDestinatario').clearValidators();
      this.integrazioneForm.get('emailBody').clearValidators();
      this.integrazioneForm.get('emailDestinatario').patchValue(null);
      this.integrazioneForm.get('emailBody').patchValue(null);
    }
    this.changeDetectorRef.detectChanges();
  }
}
